import React from "react";
import ourServicesTopBgImgPng from "../assests/ourServicesTopBgImgPng.png";
import ServicesCompUpdate from "./ServicesCompUpdate";
import serviceCompImg1 from "../assests/serviceCompImg1.png";
import serviceCompImg2 from "../assests/serviceCompImg2.png";
import serviceCompImg3 from "../assests/serviceCompImg3.png";
import serviceCompImg4 from "../assests/serviceCompImg4.png";
import serviceCompImg5 from "../assests/serviceCompImg5.png";
import serviceCompImg6 from "../assests/serviceCompImg6.png";
import groupTopLineImg from "../assests/groupTopLineImg.svg";
import groupBottomLineImg from "../assests/groupBottomLineImg.svg";

export default function ServicesUpdate() {
  return (
    <div className="servicesMain" id="services">
      <div className="servicesHeadContainer">
        {/* <img
          style={{ width: "100%", objectFit: "cover" }}
          src={ourServicesTopBgImg}
          alt=""
        /> */}
        <div className="servicesHeadings">
          <h1 className="servicesHeadingText">Services</h1>
          <p className="servicesParaText">
            Tailored real estate solutions for secure investments, expert
            guidance, and seamless transactions.
          </p>
        </div>
      </div>

      <div style={{ position: "relative" }}>
        <ServicesCompUpdate
          reverse
          serviceCompImg={serviceCompImg2}
          serviceCompText="Document Verification"
          serviceCompPara="Ensure authentic property documents and safeguard transactions."
        />

        <div className="serviceBgGroupImg">
          {/* <img style={{ width: "100%" }} src={groupBottomLineImg} alt="" /> */}
        </div>
      </div>
      <ServicesCompUpdate
        serviceCompImg={serviceCompImg3}
        serviceCompText="Property Consultation"
        serviceCompPara="Expert advice for buying, selling, and investing in real estate."
      />

      <div style={{ position: "relative" }}>
        <div className="serviceBgGroupImg1">
          {/* <img style={{ width: "100%" }} src={groupTopLineImg} alt="" /> */}
        </div>
        <ServicesCompUpdate
          reverse
          serviceCompImg={serviceCompImg4}
          serviceCompText="Property Investment"
          serviceCompPara="Identify and secure high-return real estate opportunities."
        />

        <div className="serviceBgGroupImg">
          {/* <img style={{ width: "100%" }} src={groupBottomLineImg} alt="" /> */}
        </div>
      </div>

      <ServicesCompUpdate
        serviceCompImg={serviceCompImg1}
        serviceCompText="Joint Venture"
        serviceCompPara="Collaborate with investors and developers for profitable projects."
      />

      {/* <div style={{ position: "relative" }}>
        <div className="serviceBgGroupImg1">
        </div>

        <ServicesCompUpdate
          serviceCompImg={serviceCompImg5}
          serviceCompText="IT Staffing "
          serviceCompPara="Our highly efficient & experienced team provides IT Staffing solutions to companies across Gulf countries, India, Pakistan and USA. Our IT Staff Augmentation team has successfully delivered both short-term and long-term solutions as well as project-based deployment and and we provide our customers , an accurate and concise talent management solutions that match with a particular industry, geography, or business requirement."
        />
        <div className="serviceBgGroupImg">
        </div>
      </div>

      <ServicesCompUpdate
        reverse
        serviceCompImg={serviceCompImg6}
        serviceCompText="Payroll Services"
        serviceCompPara="Managing payroll, accounting, and all other financial responsibilities in house and at once is time-consuming and prone to errors. We work in partnership with our clients to develop, implement and manage bespoke payroll services. Our services are in line with the WPS and our clients enjoy considerable cost savings and can focus on core activities of the business."
      /> */}
    </div>
  );
}
